<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="segmentos"
        :headers="headers"
        :rotina-id="ID_TELA_DE_SEGMENTO"
        :configurar="false"
        :loading="loading"
        @create="() => abrirDialogCriarSegmento()"
        @update="(indice) => abrirDialogEditarSegmento(indice)"
        @delete="(indice) => openDialogDeleteSegmento(indice)"
      />
      <DialogDeEdicaoDeSegmento
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :segmento-param="segmentoParam"
        :itens="itensParam"
        @confirmado="atualizarSegmento"
      />
      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogDeleteSegmento" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="segmentoDelete">
            Tem certeza que deseja excluir o segmento <b> {{ segmentoDelete.descricao }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeleteSegmento = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="removerSegmento">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import SegmentoService from '../../../services/segmento/segmento'
import SnackbarMessage from '../../../components/SnackbarMessage'
import DialogDeEdicaoDeSegmento from '../../../components/segmentos/DialogDeEdicaoDeSegmento'
import DataTableDeCrud from '../../../components/DataTableDeCrud'
import SnackBar from '../../../models/components/snackbar'
import Segmento from '../../../models/segmento'
import { ID_TELA_DE_SEGMENTO } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeSegmento
  },
  data: () => ({
    name: 'TelaDeSegmento',
    headers: [
      { text: 'Código', value: 'codigo' },
      { text: 'Descrição', value: 'descricao' }
    ],
    segmentos: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    segmentoParam: new Segmento(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogDeleteSegmento: false,
    segmentoDelete: new Segmento(),
    indiceSegmentoDelete: 0,
    ID_TELA_DE_SEGMENTO: ID_TELA_DE_SEGMENTO
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        this.loadSegmentos()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar segmentos cadastrados.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadSegmentos() {
      this.loading = true
      const response = await SegmentoService.getAll()
      this.segmentos = response.map((item) => ({
        ...item
      }))
      this.loading = false
    },

    atualizarSegmento(segmento) {
      if (!segmento) return

      const indice = this.segmentos.findIndex(
        (segmentoExistente) => segmentoExistente.id === segmento.id
      )

      if (indice === -1) {
        this.segmentos.push(segmento)
        this.snackbar.snackTextParam = 'Segmentos criado com sucesso.'
      } else {
        this.segmentos.splice(indice, 1, segmento)
        this.snackbar.snackTextParam = 'Segmento atualizado com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    openDialogDeleteSegmento(indice) {
      this.segmentoDelete = this.segmentos[indice]
      if (!this.segmentoDelete.id) return

      this.indiceSegmentoDelete = indice
      this.dialogDeleteSegmento = true
    },

    async removerSegmento() {
      try {
        await SegmentoService.deleteById(this.segmentoDelete.id)
        this.snackbar.snackTextParam = 'Segmento removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.segmentos.splice(this.indiceSegmentoDelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeleteSegmento = false
    },

    abrirDialogCriarSegmento() {
      this.operacao = 'adicionar'
      this.itensParam = {}
      this.segmentoParam = new Segmento()
      this.showDialogParam = true
    },

    abrirDialogEditarSegmento(indice) {
      this.operacao = 'editar'
      this.itensParam = {}
      this.segmentoParam = { ...this.segmentos[indice] }
      this.showDialogParam = true
    }
  }
}
</script>
